import { ReactNode } from "react";

import PropTypes from "prop-types";

import { Button, ButtonsWrapper } from "components/elements";
import { Modal } from "components/modals";

import styles from "./Modal.scss";

type ConfirmModalProps = {
  isSubmiting: boolean;
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;

  cancelLabel: string;
  confirmLabel: string;
  title: string;
  description: string | ReactNode;
  size?: "small" | "medium" | "big" | "huge";
};

export const ConfirmModal = ({
  isSubmiting,
  onConfirm,
  onClose,
  isOpen,
  cancelLabel,
  confirmLabel,
  title,
  description,
  size = "small",
}: ConfirmModalProps) => {
  return (
    <Modal
      className={styles.modal}
      onClose={onClose}
      isOpen={isOpen}
      title={title}
      size={size}
      actions={
        <ButtonsWrapper>
          <Button
            processing={isSubmiting}
            disabled={isSubmiting}
            type="normal"
            onClick={onClose}
          >
            {cancelLabel}
          </Button>
          <Button
            type="green"
            processing={isSubmiting}
            disabled={isSubmiting}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </ButtonsWrapper>
      }
    >
      <p className={styles.textWrapper}>{description}</p>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  isSubmiting: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,

  cancelLabel: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["small", "medium", "big", "huge"]),
};
